import {radiusSliderState, CHANGE_EVENT} from './radiusSlider';
import { slide } from '../pointSizeSlider/actions'; 
import {lineThickSliderState} from './lineThickSlider';
import {sliderStateStudents} from './sliderStateStudents';
import {map} from '../map/map';
import customConnect from '../customConnect';
import VectorLayer from 'ol/layer/Vector';


export default function(store){

    var refresh = function(){
        var layers = map.getLayers().getArray();
        for (let i = layers.length - 1; i >= 0; i--) {
            var layer = layers[i];
        //  console.log('layer: ', layer, layer instanceof ol.layer.Vector);
            if(layer instanceof VectorLayer)
            {
            //  console.log('layer', layer);
                var style = layer.getStyle();
                layer.setStyle(style);
            }

        }
    }

    radiusSliderState.setSlider();

 /*   radiusSliderState.on(CHANGE_EVENT, function() {

        store.dispatch(slide(radiusSliderState.getPercent()));
    });
*/
    

    radiusSliderState.on('change', refresh);
    lineThickSliderState.on('change', refresh);
 //   sliderStateStudents.on('change', refresh);

    //Connect radius slider state to redux
    customConnect((state) => {

        return {
                size: state.pointSizeSlider.percent
            }
        },
        (dispatcher) => {

        },
        store,
        ({size}) => {
            radiusSliderState.setSlider(size);
        }
    )
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/slider/map.js